// extracted by mini-css-extract-plugin
export default {"container":"UploadModal_container__Ht9cb","upload":"UploadModal_upload__xgO8j","dropContainer":"UploadModal_dropContainer__n8WOP"};